(function () {
  class GambleSpin extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;

      this._collectButton = undefined;
      this._bonusArrow = undefined;
      this._gambleDisc = undefined;
      this._winAnim = undefined;
      this._touchToGamble = undefined;
      this._pointerFinger = undefined;

      this._initWinnings = 0;
      this._currentCashWinnings = 0;
      this._winCapped = false;

      this.moveFinger = false;
      this.fingerMoving = false;
      this.fingerTimer = undefined;

      this._bonusWinStartAngle = undefined;
      this._bonusWinEndAngle = undefined;
      this._loseStartAngle = undefined;
      this._bonusLoseEndAngle = undefined;

      this._currentWin = 0;

      this._pulseTween = undefined;

      this._selectSounds = ["gambleDecrease", "gambleIncrease"];

      this._bonusEmitter = undefined;
      this._cashEmitter = undefined;

      this._hasGambled = false;

      this._bonusOptions = undefined;
      this._cashOptions = undefined;

      this._callback = undefined;

      this._collected = false;
      this._buttonsActive = false;

      this._recover = false;
      this._recoverSubsequent = false;
      this._removeRecovery = false;

      this._spinnerTimeline = undefined;

      this._currentBonusLevel = 0;
      this._maxBonusLevel = 0;
      this._nextFreeSpins = 0;
      this._bonusAvailable = true;
      this._cashAvailable = true;
      this._bonusCommands = [
        "GAMBLE_BONUS_0",
        "GAMBLE_BONUS_1",
        "GAMBLE_BONUS_2",
        "GAMBLE_BONUS_3",
      ];
      this._cashCommands = [
        "GAMBLE_CASH_0",
        "GAMBLE_CASH_1",
        "GAMBLE_CASH_2",
        "GAMBLE_CASH_3",
      ];

      this._currentPrizeType = "cash";
      this._maxCashLevel = 0;
      this._currentCashLevel = 0;
      this._nextCash = 0;

      this._commandCheck = false;

      let self = this;
      StateMachine.Create(this);
      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState("IDLE", function () {});
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });

      messageBus.subscribe(
        "spinner:GambleDataEvent",
        this.onGambleDataEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:GambleDataEventDead",
        this.onGambleDataEventEnd.bind(this)
      );
      messageBus.subscribe(
        "spinner:GambleResultEvent",
        this.onGambleResultEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:GambleCommandSent",
        this.onCommandSent.bind(this)
      );
      messageBus.subscribe("common:RecoverGame", this.recoverGame.bind(this));
      messageBus.subscribe(
        "Gamble:RemoveRecoveryFlag",
        this.removeRecoveryFlag.bind(this)
      );
    }

    recoverGame() {
      if (this._removeRecovery) {
        return;
      }

      this._recover = true;
      this._recoverSubsequent = false;
    }

    removeRecoveryFlag() {
      this._recover = false;
      this._recoverSubsequent = false;
      this._removeRecovery = true;

      this._collectButton.visible = true;
      this._collectButton.interactive = true;

      this.checkDirectionButton("bonus");
      this.checkDirectionButton("cash");
    }

    onGambleDataEventEnd() {
      if (!this._collected) {
        gdk.getNextGameOutcome(function () {});
      }
    }

    onCommandSent() {
      if (this._commandCheck) {
        gdk.getNextGameOutcome(function () {});
        this._commandCheck = false;
      }
    }

    readyForResult() {}

    onGambleDataEvent(task) {
      task.join();

      this._collected = false;

      this._currentPrizeType = "cash";

      this.checkPrepareGamble(task);
    }

    onGambleResultEvent(task) {
      if (this._hasGambled) {
        const self = this;
        let temp = task;
        temp.join();

        musicManager.gambleSpin();

        this.spinToResult(task, function () {
          temp.leave();
          temp = undefined;
          self._resultShownCb = undefined;
        });
      }
    }

    checkPrepareGamble(task) {
      if (
        !gdk.getPlatformAllowsGamble() ||
        gameController.gambleMode === "off" ||
        (task.data.bonusGambleOptions.length === 0 &&
          task.data.cashGambleOptions.length === 0)
      ) {
        this.onDecisionMade(task, task.data.resultCallback, "COLLECT", true);
        return;
      } else if (gameController.gambleMode === "five") {
        if (
          gameController.totalWinnings <
          resourceManager.getController("stakeController").BaseStake * 5
        ) {
          this.onDecisionMade(task, task.data.resultCallback, "COLLECT", true);
          return;
        }
      }

      timerManager.addTimeout(800, () => {
        this.prepareGamble(task);
      });
    }

    prepareGamble(task) {
      musicManager.gambleEnter();

      this.setButtonActive(this._bonusPrev, true);
      this.setButtonActive(this._bonusNext, true);
      this.setButtonActive(this._cashPrev, true);
      this.setButtonActive(this._cashNext, true);

      resourceManager.get("gambleBacker").visible = false;

      this._collectButton.alpha = 1;

      this._recoverSubsequent = false;

      this._currentBonusLevel = 0;
      this._currentCashLevel = 1;

      this._bonusArrow.rotation = Math.PI / 2;
      this._cashArrow.rotation = Math.PI / 2;

      this._callback = this.onDecisionMade.bind(
        this,
        task,
        task.data.resultCallback
      );

      this.start(
        task.data.bonusGambleOptions,
        task.data.cashGambleOptions,
        true
      );

      this.enterAnim();

      this.setCurrentPrize("cash", gameController.totalWinnings);

      this._initWinnings = gameController.totalWinnings;
      this._currentCashWinnings = gameController.totalWinnings;
    }

    onDecisionMade(task, resultCallback, gambleDecision, shouldLeave = false) {
      resultCallback({ response: gambleDecision }, function () {
        if (gambleDecision !== "COLLECT" || shouldLeave) {
          task.leave();
        }
      });
    }

    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }

      if (this.moveFinger && !this.fingerMoving) {
        let self = this;
        this.fingerMoving = true;
        timerManager.addTimer(
          1000,
          function (progress) {
            self._pointerFinger.position.setX(
              self.fingerStartX + 20 * Math.abs(Math.sin(Math.PI * progress))
            );
          },
          function () {
            self.fingerMoving = false;
          }
        );
      }
    }

    onLayoutComplete() {
      this._gambleScreen = resourceManager.get(
        "gambleSpinContainer:GambleSpin"
      );
      this._touchToGambleText = resourceManager.get(
        "gambleSpinContainer:GambleSpin:gamblePanel:touchToGambleContainer"
      );

      this._resultText = resourceManager.get(
        "gambleSpinContainer:GambleSpin:resultMessage"
      );
      this._resultText.visible = false;

      this._bonusGamble = resourceManager.get(
        "gambleSpinContainer:GambleSpin:bonusGamble"
      );
      this._bonusGambleText = resourceManager.get(
        "gambleSpinContainer:GambleSpin:bonusButtons:numFreeSpinsText"
      );

      this._bonusPrev = resourceManager.get(
        "gambleSpinContainer:GambleSpin:bonusButtons:prevButton"
      );
      this._bonusPrev.mousedown = () => this.selectButtonPressed("bonus", -1);
      this._bonusPrev.touchstart = () => this.selectButtonPressed("bonus", -1);

      this._bonusNext = resourceManager.get(
        "gambleSpinContainer:GambleSpin:bonusButtons:nextButton"
      );
      this._bonusNext.mousedown = () => this.selectButtonPressed("bonus", 1);
      this._bonusNext.touchstart = () => this.selectButtonPressed("bonus", 1);

      this._bonusArrow = resourceManager.get(
        "gambleSpinContainer:GambleSpin:bonusGamble:gambleArrow"
      );
      this._bonusSpinnerBacking = resourceManager.get(
        "gambleSpinContainer:GambleSpin:bonusGamble:gambleSegmentsBacking"
      );
      this._bonusSpinnerBacking.alpha = 0;
      this._bonusSpinner = resourceManager.get(
        "gambleSpinContainer:GambleSpin:bonusGamble:gambleSegments"
      );
      this._bonusSpinner.mousedown = () => this.onCommittedToGamble("bonus");
      this._bonusSpinner.touchstart = () => this.onCommittedToGamble("bonus");

      this._cashGamble = resourceManager.get(
        "gambleSpinContainer:GambleSpin:cashGamble"
      );
      this._cashGambleText = resourceManager.get(
        "gambleSpinContainer:GambleSpin:cashButtons:cashText"
      );

      this._cashPrev = resourceManager.get(
        "gambleSpinContainer:GambleSpin:cashButtons:prevButton"
      );
      this._cashPrev.mousedown = () => this.selectButtonPressed("cash", -1);
      this._cashPrev.touchstart = () => this.selectButtonPressed("cash", -1);

      this._cashNext = resourceManager.get(
        "gambleSpinContainer:GambleSpin:cashButtons:nextButton"
      );
      this._cashNext.mousedown = () => this.selectButtonPressed("cash", 1);
      this._cashNext.touchstart = () => this.selectButtonPressed("cash", 1);

      this._cashArrow = resourceManager.get(
        "gambleSpinContainer:GambleSpin:cashGamble:gambleArrow"
      );
      this._cashSpinner = resourceManager.get(
        "gambleSpinContainer:GambleSpin:cashGamble:gambleSegments"
      );
      this._cashSpinnerBacking = resourceManager.get(
        "gambleSpinContainer:GambleSpin:cashGamble:gambleSegmentsBacking"
      );
      this._cashSpinnerBacking.alpha = 0;
      this._cashSpinner.mousedown = () => this.onCommittedToGamble("cash");
      this._cashSpinner.touchstart = () => this.onCommittedToGamble("cash");

      this._currentPrizeText = resourceManager.get(
        "gambleSpinContainer:GambleSpin:collectionPanel:collectionPanelText"
      );

      this._collectButton = resourceManager.get(
        "gambleSpinContainer:GambleSpin:collectButton"
      );
      this._collectButton.mousedown = this._collectButton.touchstart =
        this.onClickedToContinue.bind(this);

      this._gambleContainer = resourceManager.getContainer(
        "gambleIntroContainer"
      );
      this._gambleDisclaimer = resourceManager.get(
        "gambleDisclaimerContainer:GambleDisclaimer"
      );

      this._bonusWinText = resourceManager.get(
        "gambleSpinContainer:GambleSpin:bonusGamble:win"
      );
      this._bonusLoseText = resourceManager.get(
        "gambleSpinContainer:GambleSpin:bonusGamble:lose"
      );
      this._cashWinText = resourceManager.get(
        "gambleSpinContainer:GambleSpin:cashGamble:win"
      );
      this._cashLoseText = resourceManager.get(
        "gambleSpinContainer:GambleSpin:cashGamble:lose"
      );
      this._bonusWinText.visible = false;
      this._bonusLoseText.visible = false;
      this._cashWinText.visible = false;
      this._cashLoseText.visible = false;

      this._upgrade1 = resourceManager.get(
        "gambleSpinContainer:GambleSpin:bonusButtons:upgrade1"
      );
      this._upgrade2 = resourceManager.get(
        "gambleSpinContainer:GambleSpin:bonusButtons:upgrade2"
      );
      this._upgrade1.visible = false;
      this._upgrade2.visible = false;

      this._pulseTween = gsap.to(this._touchToGambleText.scale, {
        duration: 0.8,
        x: 1.1,
        y: 1.1,
        yoyo: true,
        repeat: -1,
        ease: "power1.inOut",
      });

      messageBus.subscribe("Gamble:Risk", this.onGambleRisk.bind(this));
      messageBus.subscribe("Gamble:Collect", this.onGambleCollect.bind(this));
      messageBus.subscribe(
        "Gamble:ClickToContinue",
        this.onClickedToContinue.bind(this)
      );

      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );

      this._cashSpinnerBacking.beginFill(0x000000);
      this._cashSpinnerBacking.lineStyle(0, 0x000000);
      this._cashSpinnerBacking.moveTo(0, 0);
      this._cashSpinnerBacking.arc(0, 0, 170, 0, Math.PI * 2);
      this._cashSpinnerBacking.endFill();

      this._bonusSpinnerBacking.beginFill(0x000000);
      this._bonusSpinnerBacking.lineStyle(0, 0x000000);
      this._bonusSpinnerBacking.moveTo(0, 0);
      this._bonusSpinnerBacking.arc(0, 0, 170, 0, Math.PI * 2);
      this._bonusSpinnerBacking.endFill();

      this._bonusEmitter = particleManager.createEmitter(
        "gamble_emitter",
        "gambleSpinContainer:GambleSpin:bonusGamble:particlesContainer",
        0,
        0,
        false
      );
      this._bonusEmitter.particleEmitter.emit = false;

      this._cashEmitter = particleManager.createEmitter(
        "gamble_emitter",
        "gambleSpinContainer:GambleSpin:cashGamble:particlesContainer",
        0,
        0,
        false
      );
      this._cashEmitter.particleEmitter.emit = false;
    }

    onOrientationChange() {
      this._spinnerTimeline?.pause();
    }

    toggleTouchText(show) {
      this._touchToGambleText.alpha = show ? 1 : 0.5;

      if (show) {
        this._pulseTween.play(0);
      } else {
        this._pulseTween.pause(0);
      }
    }

    onGambleCollect() {
      if (!this.visible) return;

      soundManager.play("gambleCollect");

      this._collected = true;
      this._collectButton.interactive = false;
      this._commandCheck = true;
      this._hasGambled = false;

      this.exitAnim(() => {
        this.onGambleCollectAnimationsDone();
      });
    }

    onGambleCollectAnimationsDone() {
      this.alpha = 1;
      this.visible = false;

      if (this._currentPrizeType === "bonus") {
        gameController.lastPayWinsData.totalLineWinnings = 0;

        gameData.winningsMeter.set(
          gameController.lastPayWinsData.totalLineWinnings
        );

        this.end(true);
      } else {
        gameData.winningsMeter.set(this._currentCashWinnings);
        gameController.totalWinnings = this._currentCashWinnings;

        this.checkBigwin(true);
      }
    }

    checkBigwin(collected = false) {
      let bigWin = false;

      const aboveStake = this._currentCashWinnings > this._initWinnings;
      const isCapped = this._winCapped;

      if (aboveStake) {
        bigWin = gameController.bigWin.willTriggerBigWin(
          this._currentCashWinnings
        );
      }

      if (bigWin) {
        gameController.bigWin.start(
          this._currentCashWinnings,
          () => {
            this.end(true);
          },
          isCapped
        );
      } else {
        this.end(true);
      }
    }

    end(collected = false) {
      if (collected) messageBus.postImmediate("spinner:GambleCommandSent");

      if (this._resultShownCb) {
        this._resultShownCb();
      }

      if (this._recover) {
        if (this._currentPrizeType === "cash" || !this._currentWin) {
          this.stateMachine.switchState("IDLE");
          resourceManager.getController("inputOverlord").setState("enabled");
        }

        this._recover = false;
        this._recoverSubsequent = false;
        this._removeRecovery = false;
      } else {
        if (this._currentPrizeType === "cash" || !this._currentWin) {
          this.stateMachine.switchState("IDLE");
          resourceManager.getController("inputOverlord").setState("enabled");
        }
      }
    }

    onGambleRisk(task = undefined) {
      if (this._recover) {
        const command = task.data.command;
        const bonus = command.includes("BONUS");

        let type;

        if (bonus) {
          this._currentBonusLevel = this._bonusCommands.findIndex((element) =>
            element.includes(command)
          );
          type = "bonus";
        } else {
          this._currentCashLevel = this._cashCommands.findIndex((element) =>
            element.includes(command)
          );
          type = "cash";
        }

        if (this._bonusAvailable) {
          this._nextFreeSpins =
            this._bonusOptions[this._currentBonusLevel].winningBonusLevel;
          this._bonusGambleText.setTranslationParameters(
            this._nextFreeSpins * 5
          );
        } else {
          this._nextFreeSpins = undefined;
          this._bonusGambleText.setTranslationPhrase("t_maxSpinsReached");
        }

        if (this._cashAvailable) {
          this._nextCash = this._cashOptions[this._currentCashLevel].winAmount;
          this._cashGambleText.text = gdk.formatCurrency(this._nextCash);
        } else {
          this._nextCash = undefined;
          this._cashGambleText.setTranslationPhrase("t_maxGambleReached");
        }

        this._currentPrizeType = type;

        this.setupWheel();
        this.checkDirectionButton("bonus");
        this.checkDirectionButton("cash");

        this.fadeWheel(true, type);
      }

      const isBonus = this._currentPrizeType === "bonus";
      const commands = isBonus ? this._bonusCommands : this._cashCommands;
      const level = isBonus ? this._currentBonusLevel : this._currentCashLevel;

      if (this._hasGambled) {
        this._commandCheck = true;
      }

      this._collectButton.interactive = false;
      this.resetFinger();

      this._callback(commands[level]);

      if (this._recoverSubsequent) {
        gdk.getNextGameOutcome();
      }

      this._hasGambled = true;

      this._bonusSpinner.interactive = false;
      this._cashSpinner.interactive = false;

      this.setButtonActive(this._bonusPrev, false);
      this.setButtonActive(this._bonusNext, false);
      this.setButtonActive(this._cashPrev, false);
      this.setButtonActive(this._cashNext, false);
    }

    resetFinger() {
      if (this.fingerTimer !== undefined) {
        timerManager.stop(this.fingerTimer);
        this.fingerTimer = undefined;
      }

      this.moveFinger = false;
      this.fingerMoving = false;
      this._bonusEmitter.particleEmitter.emit = false;
      this._cashEmitter.particleEmitter.emit = false;
      this.stateMachine.switchState("IDLE");
    }

    onCommittedToGamble(type) {
      if (
        !this._buttonsActive ||
        gdk.getServerParser()._inReplayMode ||
        gdk.getServerParser()._inRewatchMode ||
        this._recover
      )
        return;

      const avail =
        type === "cash" ? this._cashAvailable : this._bonusAvailable;

      if (!avail) {
        return;
      }

      this._currentPrizeType = type;

      this.fadeWheel(true, type);

      messageBus.postImmediate("Gamble:Risk");
    }

    onClickedToContinue(ignoreButtonsInactive = false) {
      if (!ignoreButtonsInactive && !this._buttonsActive) return;

      this._buttonsActive = false;
      this._collectButton.alpha = 0.5;

      this._callback("COLLECT");
    }

    start(bonusGambleOptions, cashGambleOptions, animatingIn = false) {
      this._currentBonusLevel = 0;

      this._buttonsActive = true;

      resourceManager.getController("inputOverlord").setState("gamble");

      this._gambleContainer.visible = true;
      this.visible = true;

      this.fadeWheel(false, "cash");
      this.fadeWheel(false, "bonus");

      this._bonusOptions = bonusGambleOptions;
      this._cashOptions = cashGambleOptions;

      gsap.to(this._resultText, {
        duration: 0.2,
        alpha: 0,
        onComplete: () => {
          this._resultText.visible = false;
        },
      });

      this.toggleTouchText(true);

      if (bonusGambleOptions.length === 0) {
        this._bonusAvailable = false;
        this._nextFreeSpins = undefined;
      } else {
        this._bonusAvailable = true;

        this._currentBonusLevel = Math.min(
          this._currentBonusLevel,
          bonusGambleOptions.length - 1
        );
        this._nextFreeSpins =
          bonusGambleOptions[this._currentBonusLevel].winningBonusLevel;
      }

      if (cashGambleOptions.length === 0) {
        this._cashAvailable = false;
        this._nextCash = undefined;
      } else {
        this._cashAvailable = true;

        this._currentCashLevel = Math.min(
          this._currentCashLevel,
          cashGambleOptions.length - 1
        );
        this._nextCash = cashGambleOptions[this._currentCashLevel].winAmount;
      }

      this._maxBonusLevel = bonusGambleOptions.length;
      this._maxCashLevel = cashGambleOptions.length;

      this._collectButton.visible = !this._recover;

      this.showPlaque();

      if (this._maxBonusLevel === 0) {
        this._bonusGambleText.setTranslationPhrase("t_maxSpinsReached");
        this._bonusGambleText.setMaxWidth(260);
        this._bonusSpinner.interactive = false;

        this.setButtonActive(this._bonusPrev, false);
        this.setButtonActive(this._bonusNext, false);
      } else {
        this._bonusGambleText.setTranslationPhrase("t_numFreeSpins");
        this._bonusGambleText.setTranslationParameters(this._nextFreeSpins * 5);
        this._bonusSpinner.interactive = true;
      }

      if (this._maxCashLevel === 0) {
        this._cashGambleText.setTranslationPhrase("t_maxGambleReached");
        this._cashGambleText.setMaxWidth(260);
        this._cashSpinner.interactive = false;

        this.setButtonActive(this._cashPrev, false);
        this.setButtonActive(this._cashNext, false);
      } else {
        this._cashGambleText.text = gdk.formatCurrency(this._nextCash);
        this._cashSpinner.interactive = true;
      }

      if (this._maxBonusLevel === 0 && this._maxCashLevel === 0) {
        this.onClickedToContinue();
      }

      this.checkDirectionButton("bonus");
      this.checkDirectionButton("cash");

      this._gambleDisclaimer.visible = false;

      if (animatingIn) {
        timerManager.addTimeout(1100, () => {
          if (this._recover) {
            messageBus.postImmediate("Gamble:WaitForInput");
          }

          this._collectButton.interactive = !this._recover;
          this._cashSpinner.interactive = !this._recover;
          this._bonusSpinner.interactive = !this._recover;
        });
      } else {
        if (this._recover) {
          messageBus.postImmediate("Gamble:WaitForInput");
        }

        this._collectButton.interactive = !this._recover;
        this._cashSpinner.interactive = !this._recover;
        this._bonusSpinner.interactive = !this._recover;
      }

      this.setupWheel();
    }

    setupWheel() {
      // === Cash Wheel
      if (this._cashAvailable) {
        const cashWinChance =
          this._cashOptions[this._currentCashLevel].winChance;
        const cashLoseChance = 1 - cashWinChance;

        const cashWinPercentage =
          (cashWinChance * 100) / (cashWinChance + cashLoseChance) / 100;
        const cashLosePercentage = 1 - cashWinPercentage;

        this._cashSpinner.clear();

        this._cashStartAngle =
          -(cashLosePercentage * Math.PI * 2) / 2 + Math.PI / 2;
        this._cashLoseEndAngle =
          (cashLosePercentage * Math.PI * 2) / 2 + Math.PI / 2;
        this._cashWinStartAngle = this._cashLoseEndAngle;
        this._cashWinEndAngle =
          this._cashLoseEndAngle + cashWinPercentage * Math.PI * 2;
      } else {
        this._cashStartAngle = 0;
        this._cashLoseEndAngle = Math.PI * 2;
        this._cashWinStartAngle = 0;
        this._cashWinEndAngle = 0;

        this.fadeWheel(true, "bonus");
      }

      // Winning arc
      this._cashSpinner.beginFill(0x00c800);
      this._cashSpinner.lineStyle(0, 0xffffff);
      this._cashSpinner.moveTo(0, 0);
      this._cashSpinner.arc(
        0,
        0,
        170,
        this._cashWinStartAngle,
        this._cashWinEndAngle
      ); // cx, cy, radius, startAngle, endAngle
      this._cashSpinner.endFill();

      // Losing arc
      this._cashSpinner.beginFill(0xc80000);
      this._cashSpinner.lineStyle(0, 0xffffff);
      this._cashSpinner.moveTo(0, 0);
      this._cashSpinner.arc(
        0,
        0,
        170,
        this._cashStartAngle,
        this._cashLoseEndAngle
      ); // cx, cy, radius, startAngle, endAngle
      this._cashSpinner.endFill();

      // === Bonus Wheel
      if (this._bonusAvailable) {
        const bonusWinChance =
          this._bonusOptions[this._currentBonusLevel].winChance;
        const bonusLoseChance = 1 - bonusWinChance;

        const bonusWinPercentage =
          (bonusWinChance * 100) / (bonusWinChance + bonusLoseChance) / 100;
        const bonusLosePercentage = 1 - bonusWinPercentage;

        this._bonusSpinner.clear();

        this._bonusStartAngle =
          -(bonusLosePercentage * Math.PI * 2) / 2 + Math.PI / 2;
        this._bonusLoseEndAngle =
          (bonusLosePercentage * Math.PI * 2) / 2 + Math.PI / 2;
        this._bonusWinStartAngle = this._bonusLoseEndAngle;
        this._bonusWinEndAngle =
          this._bonusLoseEndAngle + bonusWinPercentage * Math.PI * 2;
      } else {
        this._bonusStartAngle = 0;
        this._bonusLoseEndAngle = Math.PI * 2;
        this._bonusWinStartAngle = 0;
        this._bonusWinEndAngle = 0;

        this.fadeWheel(true, "cash");
      }

      // Winning arc
      this._bonusSpinner.beginFill(0x00c800);
      this._bonusSpinner.lineStyle(0, 0xffffff);
      this._bonusSpinner.moveTo(0, 0);
      this._bonusSpinner.arc(
        0,
        0,
        170,
        this._bonusWinStartAngle,
        this._bonusWinEndAngle
      ); // cx, cy, radius, startAngle, endAngle
      this._bonusSpinner.endFill();

      // Losing arc
      this._bonusSpinner.beginFill(0xc80000);
      this._bonusSpinner.lineStyle(0, 0xffffff);
      this._bonusSpinner.moveTo(0, 0);
      this._bonusSpinner.arc(
        0,
        0,
        170,
        this._bonusStartAngle,
        this._bonusLoseEndAngle
      ); // cx, cy, radius, startAngle, endAngle
      this._bonusSpinner.endFill();
    }

    spinToResult(task, callback) {
      this._currentWin = task.data.won;
      this._resultShownCb = callback;
      this._collectButton.visible = false;
      this._buttonsActive = false;
      this._winCapped = task.data.winCapped;

      this.toggleTouchText(false);

      this._cashSpinner.interactive = false;
      this._bonusSpinner.interactive = false;

      this.setButtonActive(this._bonusPrev, false);
      this.setButtonActive(this._bonusNext, false);
      this.setButtonActive(this._cashPrev, false);
      this.setButtonActive(this._cashNext, false);

      let totalSpins = 3;
      let spinAngle = undefined;
      let safetyAngle = 0.087;

      const isBonus = this._currentPrizeType === "bonus";

      const startAngle = isBonus ? this._bonusStartAngle : this._cashStartAngle;
      const startWinAngle = isBonus
        ? this._bonusWinStartAngle
        : this._cashWinStartAngle;
      const loseAngle = isBonus
        ? this._bonusLoseEndAngle
        : this._cashLoseEndAngle;
      const winEndAngle = isBonus
        ? this._bonusWinEndAngle
        : this._cashWinEndAngle;

      if (this._currentWin) {
        spinAngle =
          startWinAngle +
          safetyAngle +
          gameController.rng.nextFloat() *
            (winEndAngle - safetyAngle - (startWinAngle + safetyAngle));
      } else {
        spinAngle =
          startAngle +
          safetyAngle +
          gameController.rng.nextFloat() *
            (loseAngle - safetyAngle - (startAngle + safetyAngle));
      }

      const otherSpin =
        startAngle +
        safetyAngle +
        task.data.otherGambleSpinStop * (Math.PI / 180);
      const totalOtherSpin =
        totalSpins * Math.PI * 2.0 + otherSpin + Math.PI / 2;

      let totalSpinDistance =
        totalSpins * Math.PI * 2.0 + spinAngle + Math.PI / 2;
      let totalTime = 2600;

      let self = this;

      const bonusSpinDis =
        this._currentPrizeType === "bonus" ? totalSpinDistance : totalOtherSpin;

      timerManager.addTimeout(totalTime, function () {
        self.resultLanded(task);
      });

      // === Bonus
      if (this._bonusAvailable) {
        this._bonusEmitter.particleEmitter.emit = true;

        timerManager.addTimer(
          totalTime,
          function (progress) {
            var easedRotation =
              Math.sqrt(1 - Math.pow(progress - 1, 2)) * bonusSpinDis;

            self._bonusArrow.rotation = easedRotation;

            var emitterAngle = easedRotation - Math.PI / 2;

            var xx = 120 * Math.cos(emitterAngle);
            var yy = 120 * Math.sin(emitterAngle);

            self._bonusEmitter.particleEmitter.spawnPos.x =
              self._bonusArrow.position.x + xx;
            self._bonusEmitter.particleEmitter.spawnPos.y =
              self._bonusArrow.position.y + yy;
          },
          function () {}
        );
      }

      // === Cash
      if (this._cashAvailable) {
        this._cashEmitter.particleEmitter.emit = true;

        const cashSpinDis =
          this._currentPrizeType === "cash"
            ? totalSpinDistance
            : totalOtherSpin;

        timerManager.addTimer(
          totalTime,
          function (progress) {
            var easedRotation =
              Math.sqrt(1 - Math.pow(progress - 1, 2)) * cashSpinDis;

            self._cashArrow.rotation = easedRotation;

            var emitterAngle = easedRotation - Math.PI / 2;

            var xx = 120 * Math.cos(emitterAngle);
            var yy = 120 * Math.sin(emitterAngle);

            self._cashEmitter.particleEmitter.spawnPos.x =
              self._cashArrow.position.x + xx;
            self._cashEmitter.particleEmitter.spawnPos.y =
              self._cashArrow.position.y + yy;
          },
          function () {}
        );
      }
    }

    resultLanded(task) {
      musicManager.gambleLand();

      this._bonusEmitter.particleEmitter.emit = false;
      this._cashEmitter.particleEmitter.emit = false;

      if (this._currentWin) {
        soundManager.play("gambleWin");

        this.setCurrentPrize(
          this._currentPrizeType,
          task.data.won,
          this._nextFreeSpins
        );

        this.animateWinLoseText(true, this._currentPrizeType);

        this._resultText.setTranslationPhrase("t_wellDone");
      } else {
        this._resultText.setTranslationPhrase("t_betterLuckNextTime");

        gameController.stopCyclingWins();

        this._hasGambled = false;

        gameController.totalWinnings = 0;

        this.animateWinLoseText(false, this._currentPrizeType);

        this._currentPrizeText.text = "";

        soundManager.play("gambleLose");

        this.stateMachine.switchState("IDLE");
      }

      this._resultText.visible = true;
      this._resultText.setMaxWidth(340);
      this._resultText.setMaxHeight(40);
      this._resultText.alpha = 0;

      gsap.to(this._resultText, { duration: 0.2, alpha: 1 });

      // allow time to see results - more time on a lose
      let self = this;
      timerManager.addTimer(
        1500,
        function () {},
        function () {
          if (self._currentWin) {
            const bonus = task.data.bonusGambleOptions;
            const cash = task.data.cashGambleOptions;

            if (self._recover) {
              self._recoverSubsequent = true;
            }

            if (self.checkContinueGamble(bonus, cash)) {
              self.start(bonus, cash);
            } else {
              if (self._recover) {
                messageBus.postImmediate("Gamble:WaitForInput");
              }

              self.onClickedToContinue(true);
            }
          } else {
            self.gambleLost();
          }
        }
      );
    }

    checkContinueGamble(bonus, cash) {
      if (bonus.length > 0 || cash.length > 0) {
        return true;
      } else {
        return false;
      }
    }

    animateWinLoseText(win, type) {
      let obj = undefined;

      if (type === "bonus") {
        if (win) {
          obj = this._bonusWinText;
        } else {
          obj = this._bonusLoseText;
        }
      } else {
        if (win) {
          obj = this._cashWinText;
        } else {
          obj = this._cashLoseText;
        }
      }

      const duration = 0.7;

      obj.visible = true;
      obj.scale.set(0.5);
      obj.alpha = 0;

      gsap.to(obj, {
        duration,
        alpha: 1,
        pixi: { scaleX: 1, scaleY: 1 },
        ease: "power4.out",
        yoyo: true,
        repeat: 1,
        onComplete: () => {
          obj.visible = false;
        },
      });
    }

    gambleLost() {
      const self = this;

      gameController.lastPayWinsData = undefined;

      gameData.winningsMeter.set(0);

      this.exitAnim(() => this.end());
    }

    setCurrentPrize(type, cash, freeSpins) {
      if (type === "cash") {
        this._currentPrizeText.text = gdk.formatCurrency(cash);
        this._currentCashWinnings = cash;
      } else if (type === "bonus") {
        this._currentPrizeText.text = freeSpins * 5 + " FREE SPINS";
      }

      this._currentPrizeText.setMaxWidth(260);
    }

    fadeOut(object, duration = 0.3, delay = 0) {
      gsap.to(object, {
        duration,
        delay,
        alpha: 0,
        onComplete: () => {
          object.visible = false;
        },
      });
    }

    fadeIn(object, duration = 0.3, delay = 0, cb = undefined) {
      object.alpha = 0;
      object.visible = true;

      gsap.to(object, {
        duration,
        delay,
        alpha: 1,
        onComplete: () => {
          if (cb != undefined) {
            cb();
          }
        },
      });
    }

    enterAnim() {
      soundManager.play("gambleEnter");

      this.fadeIn(this, 0.3, 0.3);
      this.fadeOut(resourceManager.get("preReels"));
      this.fadeOut(resourceManager.get("slotContainer"));
      this.fadeOut(resourceManager.get("postReels"));
      this.fadeOut(resourceManager.get("fishermenOverlayContainer"));
      this.fadeOut(resourceManager.get("fishermenMultiplierOverlayContainer"));

      autoplayManager.dialog.buttonGlow.visible = false;

      const goTo = this._cashGamble.y;

      this._cashGamble.y = -this._cashGamble.height;

      this._bonusGamble.y = -this._bonusGamble.height;

      this._spinnerTimeline = gsap
        .timeline()
        .to(this._cashGamble, {
          duration: 1.1,
          delay: 0.3,
          y: goTo,
          ease: "elastic.out(0.2, 0.2)",
        })
        .to(
          this._bonusGamble,
          {
            duration: 1.1,
            y: goTo,
            ease: "elastic.out(0.2, 0.2)",
          },
          "<+=0.2"
        );
    }

    exitAnim(cb) {
      soundManager.play("gambleExit");
      musicManager.gambleExit();

      this._buttonsActive = false;

      this.fadeIn(resourceManager.get("preReels"), 0.3, 0.4);
      this.fadeIn(resourceManager.get("slotContainer"), 0.4, 0.4);
      this.fadeIn(resourceManager.get("postReels"), 0.3, 0.4);
      this.fadeIn(resourceManager.get("fishermenOverlayContainer"), 0.3, 0.4);
      this.fadeIn(
        resourceManager.get("fishermenMultiplierOverlayContainer"),
        0.3,
        0.4,
        () => {
          if (autoplayManager.isAutoplayEnabled()) {
            autoplayManager.dialog.buttonGlow.visible = true;
          }

          this._spinnerTimeline = undefined;
          this._cashGamble.y = yPos;
          this._bonusGamble.y = yPos;

          if (cb) {
            cb();
          }
        }
      );

      const yPos = this._cashGamble.y;
      const goTo = -this._cashGamble.height;

      this.fadeOut(this, 0.3, 0.3);

      this._spinnerTimeline = gsap
        .timeline()
        .to(this._cashGamble, {
          duration: 0.6,
          y: goTo,
          ease: "power1.in",
        })
        .to(
          this._bonusGamble,
          {
            duration: 0.6,
            y: goTo,
            ease: "power1.in",
          },
          "<"
        );
    }

    selectButtonPressed(type, direction) {
      if (!this._buttonsActive) return;

      if (type === "bonus") {
        this._currentBonusLevel += direction;
        this._currentBonusLevel = Math.max(
          0,
          Math.min(this._currentBonusLevel, this._maxBonusLevel - 1)
        );

        this._nextFreeSpins =
          this._bonusOptions[this._currentBonusLevel].winningBonusLevel;

        if (this._bonusAvailable) {
          this._bonusGambleText.setTranslationParameters(
            this._nextFreeSpins * 5
          );
        } else {
          this._bonusGambleText.text = "";
        }

        this.showPlaque();
      } else if (type === "cash") {
        this._currentCashLevel += direction;
        this._currentCashLevel = Math.max(
          0,
          Math.min(this._currentCashLevel, this._maxCashLevel - 1)
        );

        this._nextCash = this._cashOptions[this._currentCashLevel].winAmount;

        if (this._cashAvailable) {
          this._cashGambleText.text = gdk.formatCurrency(this._nextCash);
        } else {
          this._cashGambleText.text = "";
        }
      }

      if (direction === 1) {
        soundManager.play(this._selectSounds[1]);
      } else {
        soundManager.play(this._selectSounds[0]);
      }

      this.checkDirectionButton(type);
      this.setupWheel();
    }

    showPlaque() {
      if (this._nextFreeSpins === 3) {
        this._upgrade1.visible = true;
        this._upgrade2.visible = false;
      } else if (this._nextFreeSpins === 4) {
        this._upgrade1.visible = false;
        this._upgrade2.visible = true;
      } else {
        this._upgrade1.visible = false;
        this._upgrade2.visible = false;
      }
    }

    checkDirectionButton(type) {
      if (type === "bonus") {
        this.setButtonActive(this._bonusPrev, this._currentBonusLevel !== 0);
        this.setButtonActive(
          this._bonusNext,
          this._currentBonusLevel !== this._maxBonusLevel - 1 &&
            this._maxBonusLevel > 0
        );
      } else if (type === "cash") {
        this.setButtonActive(this._cashPrev, this._currentCashLevel !== 0);
        this.setButtonActive(
          this._cashNext,
          this._currentCashLevel !== this._maxCashLevel - 1 &&
            this._maxCashLevel > 0
        );
      }

      if (this._recover) {
        this._cashPrev.interactive = false;
        this._cashNext.interactive = false;
        this._bonusPrev.interactive = false;
        this._bonusNext.interactive = false;
      }
    }

    fadeWheel(fade, type) {
      const wheel =
        type === "bonus" ? this._cashSpinnerBacking : this._bonusSpinnerBacking;

      wheel.alpha = fade ? 0.3 : 0;
    }

    setButtonActive(button, active) {
      button.interactive = active;
      button.alpha = active ? 1 : 0.5;
    }
  }

  let gambleSpinCreator = function (json) {
    return new GambleSpin();
  };

  let gambleSpinInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  let gambleSpinFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "GambleSpin",
    gambleSpinCreator,
    gambleSpinInitialiser,
    gambleSpinFilesRequired
  );
})();
